export const getRawCryptoList = networkList => {
  const rawMethods = [];

  for (const network in networkList) {
    const currencyList = Object.keys(networkList[network]?.coins);
    rawMethods.push({ [network]: currencyList });
  }
  return rawMethods;
};
